import React from "react";
import { TouchableOpacity, Text, StyleSheet, View } from "react-native";
import { AppFontStyle } from "../styles/AppFontStyle";
import { AppColors } from "../utility/AppColors";
import { FlatList } from "react-native-gesture-handler";

interface Genre {
  id: number;
  title: string;
  isSelected: number;
}

type FilterEventsByTag = (tag: string, id: number) => void;

type GenreProps = {
  heading: string;
  filterEventsByTag?: FilterEventsByTag;
  arrPopularGeners?: Genre[];
};

const Genre: React.FC<GenreProps> = ({
  heading,
  filterEventsByTag,
  arrPopularGeners,
}) => {
  return (
    <View
      style={{
        marginTop: 25,
        width: "100%",
        gap: 25,
      }}
    >
      <Text style={[AppFontStyle.BOLD_ANYBODY_14, { color: AppColors.white }]}>
        {heading}
      </Text>

      <FlatList
        endFillColor="#000"
        overScrollMode="never"
        horizontal={true}
        // scrollEnabled={false}
        showsHorizontalScrollIndicator={false}
        style={{ paddingBottom: 15 }}
        data={arrPopularGeners}
        renderItem={({ item }) => (
          <TouchableOpacity
            style={{
              backgroundColor: item.isSelected
                ? AppColors.white
                : AppColors.appViolentColor_6D08C3,
              borderRadius: 10,
            }}
            onPress={() => {
              filterEventsByTag(item.title, item.id);
            }}
          >
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_12,
                {
                  paddingVertical: 12,
                  paddingHorizontal: 18,
                  color: item.isSelected
                    ? AppColors.appViolentColor_6D08C3
                    : AppColors.white,
                },
              ]}
            >
              {item.title}
            </Text>
          </TouchableOpacity>
        )}
        ItemSeparatorComponent={() => {
          return <View style={{ width: 20 }} />;
        }}
      />
    </View>
  );
};

export default Genre;
